module.exports = __webpack_public_path__ + "static/media/27OCHA2.ade7a50d.jpg";